import React from "react";
import { Row, Col, Card } from "antd";

const ImageGrid = ({ media, s3Bucket }) => {
  if (!media || media.length === 0) return null;

  const mediaLength = media.length;

  const renderMediaCard = (item, index) => {
    const isVideo = item?.type === "video";
    const mediaSrc = `${s3Bucket}${item?.path}`;

    return (
      <Card
        key={index}
        cover={
          isVideo ? (
            <video
              controls
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              src={mediaSrc}
            />
          ) : (
            <img
              alt={`media-${index}`}
              src={item.thumbnail ? `${s3Bucket}${item.thumbnail}` : mediaSrc}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          )
        }
        bordered={false}
      />
    );
  };

  // Case: Only 1 media item (Full width)
  if (mediaLength === 1) {
    return (
      <div style={{ padding: "10px" }}>
        <Row gutter={[16, 16]}>
          <Col span={24}>{renderMediaCard(media[0], 0)}</Col>
        </Row>
      </div>
    );
  }

  // Case: Two media items (Side by side)
  if (mediaLength === 2) {
    return (
      <div style={{ padding: "10px" }}>
        <Row gutter={[16, 16]}>
          {media.map((item, index) => (
            <Col span={12} key={index}>
              {renderMediaCard(item, index)}
            </Col>
          ))}
        </Row>
      </div>
    );
  }

  // Case: Three images or more
  const [firstImage, ...restImages] = media;
  return (
    <div style={{ padding: "10px" }}>
      <Row gutter={[16, 16]}>
        {/* Large Image/Video */}
        <Col span={16}>{renderMediaCard(firstImage, 0)}</Col>

        {/* Two Smaller Images/Videos */}
        <Col span={8}>
          <Row gutter={[0, 16]}>
            {restImages.slice(0, 2).map((item, index) => (
              <Col span={24} key={index}>
                {renderMediaCard(item, index)}
              </Col>
            ))}

            {/* Show "+x" overlay if there are more than 3 images */}
            {restImages.length > 2 && (
              <Col span={24}>
                <Card
                  cover={
                    <div style={{ position: "relative" }}>
                      <img
                        alt="small-overlay"
                        src={
                          restImages[2]?.thumbnail
                            ? `${s3Bucket}${restImages[2].thumbnail}`
                            : `${s3Bucket}${restImages[2]?.path}`
                        }
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          background: "rgba(0, 0, 0, 0.5)",
                          color: "white",
                          fontSize: "24px",
                        }}
                      >
                        +{restImages.length - 2}
                      </div>
                    </div>
                  }
                  bordered={false}
                />
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default ImageGrid;
